import { lightTheme } from '@/customTheme'
import Icons from '@/scenes/Editor/components/Icons'
import { useTranslation } from 'react-i18next'
import { PlanType } from './MetsiKonChoosePlan'
import { PREMIUM_FEATURES, SUPER_FEATURES } from './metsikonPlanConfig'

interface ChoosePlanContentProps {
  planActive: number
  planDetail: any
  planType: PlanType
}

function ChoosePlanContent({ planActive, planDetail, planType }: ChoosePlanContentProps) {
  const { t } = useTranslation()
  const isPremium = planType === 'premium'

  const selectedTrialDays = planActive === 2 ? planDetail?.year?.trialDays ?? 0 : planDetail?.month?.trialDays ?? 0
  const canFreeTrial = planActive === 2 ? planDetail?.year?.canFreeTrial : planDetail?.month?.canFreeTrial
  const selectedPrice = planActive === 2 ? planDetail?.year?.price : planDetail?.month?.price
  const period = planActive === 2 ? 'year' : 'month'

  const features = isPremium ? PREMIUM_FEATURES : SUPER_FEATURES

  const titleText = isPremium
    ? (canFreeTrial ? t('%d days free', { arg: selectedTrialDays }) : t('Included in Premium'))
    : t('Included in Super')

  const subtitleText = isPremium
    ? `${t(`${canFreeTrial ? 'then ' : ''}%@ per ${period}`, { arg: selectedPrice })}. ${t('Cancel anytime.')}`
    : `${t(planActive === 2 ? '%@ per year' : '%@ per month', { arg: selectedPrice ?? '' })}. ${t('Cancel anytime.')}`

  return (
    <>
      <div style={{ padding: '0 48px' }}>
        <h4 style={{ margin: 0, ...lightTheme.typography.Header20semibold }}>
          {titleText}
        </h4>
        <p style={{ marginTop: '22px', marginBottom: 0, ...lightTheme.typography.Small16Bold, fontWeight: 600 }}>
          {subtitleText}
        </p>
        {features.map((feature, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '8px',
              marginTop: '22px',
            }}
          >
            <Icons.CheckIcon fill={isPremium ? '#FF0560' : '#9d01f4'} />
            <span style={{ fontSize: '16px', fontWeight: '400', lineHeight: '24px' }}>
              {t(feature)}
            </span>
          </div>
        ))}
      </div>
      {isPremium && canFreeTrial && (
        <p style={{
          ...lightTheme.typography.Small12medium,
          color: lightTheme.colors.grayScale400,
          position: 'absolute',
          bottom: '16px',
          left: 0,
          right: 0,
          textAlign: 'center',
        }}>
          {t("Free trial available if you haven't used it before.")}
        </p>
      )}
    </>
  )
}

export default ChoosePlanContent
